import { SetExternalLibLocation } from '../engine/io/externallibs.js';
import { Loc } from '../engine/core/localization.js';
import { AddDiv, AddDomElement } from '../engine/viewer/domutils.js';
import { Embed } from './embed.js';
import { Website } from './website.js';
import { SetEventHandler, HandleEvent } from './eventhandler.js';
import { PluginType, RegisterPlugin } from './pluginregistry.js';
import { ButtonDialog, ProgressDialog } from './dialog.js';
import { ShowMessageDialog } from './dialogs.js';

import * as Engine from '../engine/main.js';
export { Engine };

import './css/icons.css';
import './css/themes.css';
import './css/core.css';
import './css/controls.css';
import './css/dialogs.css';
import './css/treeview.css';
import './css/panelset.css';
import './css/navigator.css';
import './css/sidebar.css';
import './css/website.css';
import './css/embed.css';

export const UI = {
    ButtonDialog,
    ProgressDialog,
    ShowMessageDialog,
    HandleEvent,
    Loc
};

export function SetWebsiteEventHandler (eventHandler)
{
    SetEventHandler (eventHandler);
}

export function RegisterHeaderPlugin (plugin)
{
    RegisterPlugin (PluginType.Header, plugin);
}

export function RegisterToolbarPlugin (plugin)
{
    RegisterPlugin (PluginType.Toolbar, plugin);
}

export function StartWebsite (externalLibLocation)
{
    initializeBaseUrl()

    window.addEventListener ('load', () => {
        const isEmbed = getQueryParam('isEmbed');
        console.log('isEmbed: ',isEmbed)
        if (isEmbed === 'true') {
           const logo = document.getElementById('logo_header')
           if (logo) {
            logo.style.display = 'none';
           }
        } else {
            console.log('isEmbed is false ')
            //document.getElementById('logo_header').style.display = 'flex';
        }

        setSamplesClickListeners()

        SetExternalLibLocation (externalLibLocation);

        document.getElementById ('intro_dragdrop_text').innerHTML = Loc ('Drag and drop 3D models here.');
        document.getElementById ('intro_formats_title').innerHTML = Loc ('Check an example file:');

        let website = new Website ({
            headerDiv : document.getElementById ('header'),
            headerButtonsDiv : document.getElementById ('header_buttons'),
            toolbarDiv : document.getElementById ('toolbar'),
            mainDiv : document.getElementById ('main'),
            introDiv : document.getElementById ('intro'),
            introContentDiv : document.getElementById ('intro_content'),
            fileNameDiv : document.getElementById ('main_file_name'),
            leftContainerDiv : document.getElementById ('main_left_container'),
            navigatorDiv : document.getElementById ('main_navigator'),
            navigatorSplitterDiv : document.getElementById ('main_navigator_splitter'),
            rightContainerDiv : document.getElementById ('main_right_container'),
            sidebarDiv : document.getElementById ('main_sidebar'),
            sidebarSplitterDiv : document.getElementById ('main_sidebar_splitter'),
            viewerDiv : document.getElementById ('main_viewer'),
            fileInput : document.getElementById ('open_file')
        });
        website.Load ();
    });
}

export function StartEmbed (externalLibLocation)
{
    SetExternalLibLocation (externalLibLocation);
    window.addEventListener ('load', () => {
        let embed = new Embed ({
            viewerDiv : document.getElementById ('embed_viewer'),
            websiteLinkDiv : document.getElementById ('website_link')
        });
        embed.Load ();
    });
}

function initializeBaseUrl() {
    const url = window.location.href;
    const base =
        url.includes('dev.seekmake')
            ? 'https://dev.seekmake.com/cad-tools/'
            : url.includes('staging.seekmake')
            ? 'https://staging.seekmake.com/cad-tools/'
            : 'https://seekmake.com/cad-tools/';

    window.BASE_URL = base;
}

function getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

function setSamplesClickListeners() {

    const sampleMap = new Map([
        ['3dm', 'assets/models/RhinoLogo.3dm'],
        ['3ds', 'assets/models/cubes.3ds,assets/models/texture.png'],
        ['3mf', 'assets/models/rhombicuboctahedron.3mf'],
        ['amf', 'assets/models/rook.amf'],
        ['bim', 'assets/models/MultipleMeshes.bim'],
        ['brep', 'assets/models/as1_pe_203.brep'],
        ['dae', 'assets/models/X_Bot.dae'],
        ['fbx', 'assets/models/Y_Bot.fbx'],
        ['fcstd', 'assets/models/ArchDetail.FCStd'],
        ['gltf', 'assets/models/DamagedHelmet.glb'],
        ['ifc', 'assets/models/haus.ifc'],
        ['iges', 'assets/models/as1_pe_203.igs'],
        ['step', 'assets/models/as1_pe_203.stp'],
        ['stl', 'assets/models/utah_teapot.stl'],
        ['obj', 'assets/models/solids.obj,assets/models/solids.mtl'],
        ['off', 'assets/models/cube.off'],
        ['ply', 'assets/models/cow.ply'],
        ['wrl', 'assets/models/extrusion3.wrl']
    ]);

    sampleMap.forEach((value, key) => {
        const button = document.getElementById(`${key}_sample`);
        if (button) {
            button.addEventListener('click', () => {
                let updatedUrl = '';
                const isEmbed = getQueryParam('isEmbed');
                if (isEmbed === 'true') {
                    updatedUrl = `${window.BASE_URL}?isEmbed=true#${value}`
                } else {
                    updatedUrl = `${window.BASE_URL}?isEmbed=false#${value}`
                }
                window.location.href = updatedUrl;
            });
        }
    })
   
}
